<mat-dialog-content>
  <div class="feature-loader-content">
    <div class="loader"></div>
    <div>Initializing Web Component</div>
  </div>
</mat-dialog-content>
